import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Flex } from '@rebass/grid';
import { P, A } from 'app/ui_components/tags';
import { isMobile } from 'app/helpers/utils';

// ======================
// == Styled Component ==
// ======================
/*
  All of the presentational components which are solely children
  of this React component.  There is no reason to separate
  these into their own files since there is no external
  re-use.
*/

const Container = styled(Flex).attrs({
  id: 'footer',
})`
  position: ${isMobile ? 'relative' : 'fixed'};
  z-index: 1;
  bottom: ${isMobile ? 0 : 20}px;
  left: 0;
  right: 0;
  text-align: center;
  ${isMobile && 'margin-top:40px'};
  * {
    margin: 0;
  }
`;

// =====================
// == React Component ==
// =====================

class Footer extends React.Component {
  static propTypes = {
    searching: PropTypes.bool.isRequired,
    domain: PropTypes.string.isRequired,
  };

  state = {
    message: '',
  };

  componentDidUpdate(prevProps) {
    const { domain, searching } = this.props;
    const searchCommenced = !prevProps.searching && searching;
    if (searchCommenced) {
      const copy = [
        `Our hospitality specialists are feeling good about ${domain}`,
        'Did you know? Using images or PDFs of menus on your website prevents search engines from understanding the site properly.',
      ];
      const oneOrZero = Math.round(Math.random());
      this.setState({ message: copy[oneOrZero] });
    }
  }

  render() {
    const { searching } = this.props;
    const { message } = this.state;
    return (
      <Container justifyContent="center">
        <P size={14}>
          {!searching ? (
            <React.Fragment>
              Powered by{' '}
              <A href="https://getbento.com/" target="_blank" size={14}>
                BentoBox
              </A>. Trusted by Industry Leaders.
            </React.Fragment>
          ) : (
            message
          )}
        </P>
      </Container>
    );
  }
}

const mapStateToProps = ({ step, website: { domain } }) => ({
  searching: step === 1,
  domain,
});

export default connect(mapStateToProps, null)(Footer);
